import { breakpoints } from "@brightagency/headstart-common";
import styled from "styled-components";

type Props = {
    delay?: number;
    duration?: number;
};

export const FadeSwitchAnimation = styled.div<Props>`
    &.fade-switch-enter {
        transform: translateY(20px);
        opacity: 0;

        &-active {
            transition: ${({ duration = 300 }) => duration}ms ease all;
            transition-delay: ${({ delay = 0 }) => delay}ms;
            transform: translateY(0%);
            opacity: 1;
        }
    }

    &.fade-switch-exit {
        transition: ${({ duration = 300 }) => duration}ms ease all;
        transition-delay: ${({ delay = 0 }) => delay}ms;
        transform: translateY(0%);
        opacity: 1;

        &-active {
            transform: translateY(-20px);
            opacity: 0;
        }
    }
`;

export const SectionTitle = styled.h3`
    color: white;
    font-size: 28px;
    margin-bottom: 24px;

    ${breakpoints.medium} {
        font-size: 40px;
        margin-bottom: 32px;
    }
`;

export const Section = styled.div`
    margin: 0 auto;

    ${breakpoints.small} {
        max-width: 450px;
    }

    ${breakpoints.medium} {
        max-width: 800px;
    }

    &.contentContainer{
        .buttonManager{
            ${breakpoints.medium} {
                max-width: 800px;
            }
        }
    }
`;

export const ButtonWidthManager = styled.div`
    margin: 0 auto;
    width: 100%;

    ${breakpoints.small} {
        max-width: 335px;
    }
`;

export const OuterSection = styled.div`
    width: 100%;
    max-width: 850px;
    margin: 0 auto;
    padding: 24px 0 48px 0;
    text-align: center;
    position: relative;

    ${breakpoints.large} {
        padding: 100px 0;
    }

    p {
        color: white;

        ${breakpoints.large} {
            font-size: 18px;
        }
    }
`;
